module.exports = __webpack_public_path__ + "static/media/12 Pretty Mary.848ccfea.mp3";